export default __webpack_public_path__ + "static/media/alex_l.915748a5.jpg";